import axios from '../axios'

// コース削除（admin のみ・soft delete）
const deleteCourseApi = async (courseId) => {
  return await axios.delete(`api/lms/courses/${courseId}`)
}

export default deleteCourseApi
